<template>
  <div class="content">
    <div style="font-size: 24px; color: #333333; margin-bottom: 25px">
      科研成果核算系统-评奖申报-自科
    </div>
    <div class="search">
      <el-form :model="form" label-width="130px" label-position="left">
        <!-- 第一排 -->
        <el-row :gutter="20">
          <el-col :span="5">
            <el-form-item label="事项名称：">
              <el-input v-model="form.field1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="发起人姓名：">
              <el-input v-model="form.field2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="接收时间：">
              <el-input v-model="form.field3"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="事项名称：">
              <el-input v-model="form.field4"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4"></el-col>
        </el-row>

        <!-- 第二排 -->
        <el-row :gutter="20">
          <el-col :span="5">
            <el-form-item label="发起人工号/学号：">
              <el-input v-model="form.field5"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="发起人部门：">
              <el-input v-model="form.field6"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="发起时间：">
              <el-input v-model="form.field7"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="耗时：">
              <el-input v-model="form.field8"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4"> </el-col>
        </el-row>

        <!-- 第三排和第四排类似 -->
        <el-row :gutter="20">
          <el-col :span="5">
            <el-form-item label="是否催办：">
              <el-input v-model="form.field5"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="紧急程度：">
              <el-input v-model="form.field6"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="阅读状态：">
              <el-input v-model="form.field7"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="是否关注：">
              <el-input v-model="form.field8"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 表单操作按钮 -->
        <el-row>
          <el-col style="text-align: left">
            <el-button
              type="primary"
              icon="el-icon-search"
              style="margin-right: 15px"
              >搜索</el-button
            >
            <el-button icon="el-icon-refresh-left">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table">
      <el-table :data="tableData" height="250" border style="width: 100%">
        <el-table-column prop="index" label="序号" width="180">
        </el-table-column>
        <el-table-column prop="name" label="事项名称" width="180">
        </el-table-column>
        <el-table-column prop="dbsx" label="待办"> </el-table-column>
        <el-table-column prop="fwly" label="服务来源"> </el-table-column>
        <el-table-column prop="type" label="事项类型"> </el-table-column>
        <el-table-column prop="time" label="最新收到时间"> </el-table-column>
        <el-table-column prop="person" label="被委托人"> </el-table-column>
        <el-table-column prop="type" label="事项类型"> </el-table-column>
        <el-table-column prop="time" label="最新收到时间"> </el-table-column>
        <el-table-column prop="person" label="被委托人"> </el-table-column>
        <el-table-column prop="type" label="事项类型"> </el-table-column>
        <el-table-column prop="time" label="最新收到时间"> </el-table-column>
        <el-table-column prop="person" label="被委托人"> </el-table-column>
        <el-table-column prop="address" label="设置操作">
          <template slot-scope="scope">
            <el-button
              @click="rowClick(scope.row)"
              type="text"
              size="small"
              icon="el-icon-star-off"
              >收藏</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 25px">
      <el-pagination
        background
        :current-page="currentPage4"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="100"
        layout="total, sizes, prev, pager, next, jumper"
        :total="400"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import request from "@/api/request";
export default {
  data() {
    return {
      tableData: [
        {
          index: "1",
          name: "教参申请",
          dbsx: "2",
          fwly: "教材教参系统",
          type: "流程",
          time: "2024年10月11日",
        },
      ],
      form: {
        field1: "",
        field2: "",
        field3: "",
        field4: "",
        field5: "",
        field6: "",
        field7: "",
        field8: "",
        // ...其他字段
      },
    };
  },
  created(){
    this.getSourchList()
  },
  methods: {
    getSourchList() {
      request({
        url: `/api/msg/channel/list`,
        method: "get",
      })
        .then((res) => {})
        .catch((error) => {});
    },
    rowClick() {},
  },
};
</script>
<style scoped lang="scss">
.content {
  background: white;
  border-radius: 8px;
  //   height: 1000px;
  padding: 30px;
  // margin: 50px 10% 50px 10%;
  .search {
    background: #f5f7fb;
    padding: 20px;
    ::v-deep .el-form-item__label {
      padding-right: 8px !important; /* 默认是10px */
    }
    ::v-deep .el-form-item__content {
      margin-left: 130px !important; /* 默认是10px */
    }
    .el-form-item {
      margin-bottom: 10px; /* 调整每个表单项的间距 */
    }
  }
  .table {
    margin-top: 25px;
    ::v-deep .el-table__header th {
      background-color: #f5f7fb;
      font-weight: bold;
      color: #333333;
    }
  }
}
</style>
